import { render } from "./RecapSalesMenu.vue?vue&type=template&id=3b9e5162&ts=true"
import script from "./RecapSalesMenu.vue?vue&type=script&lang=ts"
export * from "./RecapSalesMenu.vue?vue&type=script&lang=ts"

import exportComponent from "/home/adminhost/web/crevent.waroengss.id/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__